module.exports = __webpack_public_path__ + "img/sven_gottwald.97bc302f.jpg";